module.exports = __webpack_public_path__ + "img/12.87a01ed8.png";